interface WarpcastIconProps {
  className?: string
  size?: number
}

export function WarpcastIcon({ className = "", size = 20 }: WarpcastIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.9912 3.44922L13.4138 9.37318L11.8313 3.44922H8.18954L6.59188 9.41681L4.99945 3.44922H0.851562L4.70589 16.547H8.28438L9.99551 10.4649L11.7066 16.547H15.2928L19.1387 3.44922H14.9912Z"
        fill="currentColor"
      />
    </svg>
  )
}
